import React from "react";
import NotAccess from "../../components/common/userNotAccess/index";
import { IsShowFinance, IsShowScheduleSearch } from "../../utils";

function RestrictScheduleSearch(props) {
  if (IsShowScheduleSearch()) return props.children;
  return <NotAccess />;
}

export default RestrictScheduleSearch;
